export const SectionHeader = ({ title, color }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: 8,
      padding: "10px 16px",
      background: color,
      borderBottom: "0.5px solid var(--color-border-tertiary)",
    }}
  >
    <span
      style={{
        fontSize: 13,
        fontWeight: 500,
        color: "var(--color-text-primary)",
      }}
    >
      {title}
    </span>
  </div>
);
